<template>
<v-flex xs12 sm12>
  <v-card>
    <v-card-title class="indigo white--text headline">
      Anexos do paciente
    </v-card-title>
        <v-treeview
          :active.sync="active"
          :items="items"
          :load-children="fetchUsers"
          :open.sync="open"
          activatable
          color="warning"
          open-on-click
          transition
        >
          <template v-slot:prepend="{ item }">
            <v-icon v-if="!item.file" @click="fetchUsers()">folder</v-icon>
            <a :href="'https://sync.gestaoclinic.com.br/get?bucket=' + getPatient.bucket + '&key=' + item.path" target="_blank">
              <v-icon>{{ files[item.file] }}</v-icon>
            </a>
            <!-- <v-icon>{{ files[item.file] }}</v-icon> -->
          </template>
        </v-treeview>

      <v-divider vertical></v-divider>

        <v-scroll-y-transition mode="out-in">
          <v-card
            v-if="selected"
            :key="selected.id"
            class="pt-6 mx-auto"
            flat
          >
            <h3 class="headline mb-2">
              Selecione as imagem para abrir em outra janela maior, caso seja pdf, xls ou doc, click no link
            </h3>
            <v-card-text>
              <div v-if="selected.file === 'jpg'">
              <a :href="'https://sync.gestaoclinic.com.br/get?bucket=' + getPatient.bucket + '&key=' + selected.path" target="_blank">
                <v-img
                  :src="`https://sync.gestaoclinic.com.br/get?bucket=${getPatient.bucket}&key=${selected.path}`"
                  class="mb-6"
                ></v-img>
              </a>
              </div>
              <div v-else>
                <a :href="'https://sync.gestaoclinic.com.br/get?bucket=' + getPatient.bucket + '&key=' + selected.path" target="_blank">
                  <!-- <v-icon class="blue--text subheading font-weight-bold">{{ selected.file }}</v-icon> -->
                  <v-icon large>{{ files[selected.file] }}</v-icon>
                  Nome: {{ selected.name }}
                </a>
              </div>

              <!-- <v-avatar
                v-if="avatar"
                size="88"
              >
                <v-img
                  :src="`https://sync.gestaoclinic.com.br/get?bucket=hosp-coracao&key=${selected.path}`"
                  class="mb-6"
                ></v-img>
                <v-icon class="blue--text subheading font-weight-bold">{{ selected.file }}</v-icon>
              </v-avatar>
              <h3 class="headline mb-2">
                {{ selected.file }}
                <a :href="'https://sync.gestaoclinic.com.br/get?bucket=hosp-coracao&key=' + selected.path" target="_blank">
                  <v-icon class="blue--text subheading font-weight-bold">{{ selected.file }}</v-icon> {{ selected.name }}
                </a>
              </h3> -->
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </v-scroll-y-transition>
  </v-card>
</v-flex>
</template>

<script>
  // import axios from 'axios'
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  const avatars = [
    '?accessoriesType=Blank&avatarStyle=Circle&clotheColor=PastelGreen&clotheType=ShirtScoopNeck&eyeType=Wink&eyebrowType=UnibrowNatural&facialHairColor=Black&facialHairType=MoustacheMagnum&hairColor=Platinum&mouthType=Concerned&skinColor=Tanned&topType=Turban',
    '?accessoriesType=Sunglasses&avatarStyle=Circle&clotheColor=Gray02&clotheType=ShirtScoopNeck&eyeType=EyeRoll&eyebrowType=RaisedExcited&facialHairColor=Red&facialHairType=BeardMagestic&hairColor=Red&hatColor=White&mouthType=Twinkle&skinColor=DarkBrown&topType=LongHairBun',
    '?accessoriesType=Prescription02&avatarStyle=Circle&clotheColor=Black&clotheType=ShirtVNeck&eyeType=Surprised&eyebrowType=Angry&facialHairColor=Blonde&facialHairType=Blank&hairColor=Blonde&hatColor=PastelOrange&mouthType=Smile&skinColor=Black&topType=LongHairNotTooLong',
    '?accessoriesType=Round&avatarStyle=Circle&clotheColor=PastelOrange&clotheType=Overall&eyeType=Close&eyebrowType=AngryNatural&facialHairColor=Blonde&facialHairType=Blank&graphicType=Pizza&hairColor=Black&hatColor=PastelBlue&mouthType=Serious&skinColor=Light&topType=LongHairBigHair',
    '?accessoriesType=Kurt&avatarStyle=Circle&clotheColor=Gray01&clotheType=BlazerShirt&eyeType=Surprised&eyebrowType=Default&facialHairColor=Red&facialHairType=Blank&graphicType=Selena&hairColor=Red&hatColor=Blue02&mouthType=Twinkle&skinColor=Pale&topType=LongHairCurly'
  ]

  const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

  export default {
    mounted () {
      this.env = process.env.NODE_ENV
      this.users = []
      // this.$bus.$on('getMedicalRecord', this.fetchUsers())
    },
    data: () => ({
      env: null,
      files: {
        pdf: 'mdi-file-pdf',
        png: 'image',
        jpg: 'image',
        mpeg: 'image',
        doc: 'mdi-file-word',
        xls: 'mdi-file-excel'
      },
      active: [],
      avatar: null,
      open: [],
      users: []
    }),

    computed: {
      ...mapGetters('patient', ['getPatient', 'getAttachment']),
      items () {
        return [
          {
            name: 'Anexos',
            children: this.users
          }
        ]
      },
      selected () {
        if (!this.active.length) return undefined

        const id = this.active[0]

        return this.users.find(user => user.id === id)
      }
    },

    watch: {
      selected: 'randomAvatar'
    },

    methods: {
      async fetchUsers (selected) {
        if (!selected) return false
        console.log('chegou aqui11212', selected)
        let arrayItems
        let typeIcon
        this.users = []
        await pause(1500)
        const response = await this.getAttachment // await axios.get(`https://sync.gestaoclinic.com.br/list?bucket=${this.getPatient.bucket}&MaxKeys=150&prefix=imagens/${this.getPatient.id}/`)
        console.log('chegou aqui', response.data.Contents)
        if (!response.data.Contents) return false
        this.users = response.data.Contents.map((item) => {
          arrayItems = item.Key.split('_')
          typeIcon = item.Key.split('.')
          return {
            path: item.Key,
            name: moment(arrayItems[1], 'DDMMYYYY').format('DD-MM-YYYY'),
            id: item.ETag,
            file: typeIcon[1],
            icon: 'a'
          }
        })
      },
      randomAvatar () {
        this.avatar = avatars[Math.floor(Math.random() * avatars.length)]
      }
    }
  }
</script>

<style scoped>
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/patient/attachments/index.vue